// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x_Ihp_wwDTsuAXZn1xHW svg{width:20px;height:20px}`, "",{"version":3,"sources":["webpack://./ui-kit/ITooltip/TooltipWithInfoIcon/TooltipWithInfoIcon.module.scss"],"names":[],"mappings":"AACE,0BACE,UAAA,CACA,WAAA","sourcesContent":[".icon {\r\n  svg {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `x_Ihp_wwDTsuAXZn1xHW`
};
export default ___CSS_LOADER_EXPORT___;
